<div class="autowcont notopbrd m-top-ii estilo-1" *ngIf="this.screen==1">
    <div class="basicrow tabtopb f-black roboto-r f-reg">
        <div class="basicrow m-top-i text-center">
            <div class="shortcont mbot-pay">
                <app-resume [dataPay]="this.dataPay"></app-resume>
                <div class="basicrow m-top-i">
                    <div class="basicrow roboto-b f-bmed">
                        Datos de la Tarjeta
                    </div>
                    <div class="basicrow">
                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" (click)="this.tipoTJ('Visa')" name="idTipoTarjeta"
                                        id="opTarj-visa" value="Visa" />
                                </div>
                            </div>
                            <img width="100%" src="../../../assets/images/card-a.png">
                        </div>
                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" name="idTipoTarjeta" (click)="this.tipoTJ('American Express')"
                                        id="opTarj-american" value="American Express" />
                                </div>
                            </div>
                            <img width="100%" src="../../../assets/images/card-d.png">
                        </div>
                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" name="idTipoTarjeta" (click)="this.tipoTJ('Mastercard')"
                                        id="opTarj-master" value="Mastercard" />
                                </div>
                            </div>
                            <img width="100%" src="../../assets/images/card-b.png">
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Nombre y Apellido
                    </label>
                    <input placeholder="NOMBRE COMPLETO" class="inp-f" [(ngModel)]="this.NameOnCard" maxlength="30">
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; N&uacute;mero de Tarjeta
                    </label>
                    <input [appOnlyNumber] placeholder="NÚMERO DE TARJETA" class="inp-f" [(ngModel)]="this.idNroTejeta" maxlength="17" required>
                </div>
                <div class="basicrow m-bott-ii">
                    <div class="row">
                        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; Vencimiento de Tarjeta
                            </label>
                            <div class="basicrow">
                                <div class="row">
                                    <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6">
                                        <label class="label-r sidenmbr vcenter w-auto">
                                            <span class="tabcell">
                                                Mes
                                            </span>
                                        </label>
                                        <div class="autorow   mob-wid pull-right wid-debt">
                                            <div>
                                                <select class="sel-f exprdsize" id="card-month" name="card_month"
                                                    [(ngModel)]="this.fechaExp1"
                                                    style="background-image:url(/assets/images/selectabarrw.png)">
                                                    <option *ngFor="let month of this.months" value="{{month}}">
                                                        {{month}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 h-mtop-iv">
                                        <label class="label-r sidenmbr vcenter w-auto">
                                            <span class="tabcell">
                                                A&ntilde;o
                                            </span>
                                        </label>
                                        <div class="autorow   mob-wid pull-right wid-debt">
                                            <div>
                                                <select class="sel-f exprdsize" id="card-year" name="card_year"
                                                    [(ngModel)]="this.fechaExp2"
                                                    style="background-image:url(/assets/images/selectabarrw.png)">
                                                    <option *ngFor="let year of this.years" value="{{year}}">{{year}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; C&oacute;digo de Seguridad (CVV)
                            </label>
                            <input [appOnlyNumber] type="password" class="inp-f" name="cvNum" [(ngModel)]="this.cvNum" maxlength="4" autocomplete="off">
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-i">
                    <div class="basicrow roboto-b f-bmed">
                        Direcci&oacute;n de Facturaci&oacute;n
                    </div>
                    <div class="basicrow m-top-ii">
                        Por favor ingrese su direcci&oacute;n principal de facturaci&oacute;n. La direcci&oacute;n debe
                        ser valida.
                    </div>
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Direcci&oacute;n 1
                    </label>
                    <input class="inp-f" [(ngModel)]="this.direccion1">
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        Direcci&oacute;n 2 (Opcional)
                    </label>
                    <input class="inp-f" [(ngModel)]="this.direccion2">
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Ciudad
                    </label>
                    <input class="inp-f" [(ngModel)]="this.ciudad">
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Estado
                    </label>
                    <select class="sel-f " [(ngModel)]="this.estado"
                        style="background-image:url(/assets/images/selectabarrw.png)" style="width:100%;">
                        <option *ngFor="let estado of this.estados" value="{{estado.value}}">{{estado.label}}</option>
                    </select>
                </div>
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; C&oacute;digo Postal
                    </label>
                    <input [appZipCode] class="inp-f" [(ngModel)]="this.zip" maxlength="5">
                </div>
                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top-i">
                    <a class="btns def-i red pull-right vcenter" (click)="this.procesarPago();">
                        <span class="tabcell">
                            Pagar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                    <a href="/{{this.returnPage}}" class="btns def-i gray pull-left vcenter">
                        <span class="tabcell">
                            Cancelar
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
